import {DigitalPageItem} from '../../interfaces/digital-page-item';
import {ProductTypeEnum} from '../../interfaces/product-type-enum';

export const DigitalProductPageItem: DigitalPageItem = {
  ProductType: ProductTypeEnum.Paid,
  Title: 'Hello!',
  ProductCode: 'par74',
  Description:
    'Here\'s all the online content included with your <strong>A-Level Physics Complete Revision and Practice</strong>.',
  Credits:
    `<p><strong>Exam Practice Questions</strong></p>
<p><strong>Credits:</strong><br>
Contributors: Jane Cartwright, Peter Cecil, Mark Edwards, Matt Horncastle, Barbara Mascetti, Laura Morris, John Myers, Frances Rooney, Moira Steven, and Andy Williams.<br>
With thanks to Mark Edwards and George Wright for proofreading.<br>
Illustrations by: Sandy Gardner Artist, email sandy@sandygardner.co.uk<br>
Clipart from Corel&reg;
</p>

<p><strong>Practice Papers</strong></p>
<p><strong>Credits:</strong><br>
Contributors: Mark Edwards and Oliver Rigg.<br>
With thanks to Sean McParland for proofreading.<br>
Illustrations by: Sandy Gardner Artist, email sandy@sandygardner.co.uk<br>
Clipart from Corel&reg;
</p>
<p>Text, design, layout and original illustrations © Coordination Group Publications Ltd. (CGP) 2026. All rights reserved.</p>`,};